import { Link } from "react-router-dom";
import { MousePointerClick } from "lucide-react";
import { Mark } from "@/components/Mark";
import { spotImg } from "@/data/planner";

// Photo collage tiles for the teaser — iconic, instantly recognisable spots.
const TILES = [
  { id: "nyhavn", cls: "top-0 left-2 md:left-6 rotate-[-6deg] z-30" },
  { id: "tivoli", cls: "top-6 right-4 md:right-10 rotate-[7deg] z-20" },
  { id: "christiania", cls: "bottom-0 left-16 md:left-28 rotate-[4deg] z-40" },
  { id: "rosenborg", cls: "bottom-6 right-0 md:right-2 rotate-[-4deg] z-10 hidden sm:block" },
];

// Home-page teaser that replaces the full inline planner and links to /planner.
export const PlannerTeaser = () => (
  <section id="planner" data-testid="planner-teaser" className="bg-black">
    <div className="max-w-[1400px] mx-auto px-5 md:px-10 py-12 md:py-24">
      <div className="relative overflow-hidden rounded-3xl bg-[#DF3226] shadow-brut-lg p-8 md:p-14 grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-8 items-center">
        <div className="relative z-10">
          <div className="inline-flex items-center gap-2 mb-4">
            <p className="font-body font-800 text-xs tracking-[0.3em] eyebrow text-white/70">FREE DAY PLANNER</p>
          </div>
          <h2 className="font-display font-900 tracking-tighter leading-[0.9] text-4xl sm:text-5xl lg:text-6xl text-white">
            Build your trip,<br />
            <span className="font-editorial italic font-600">by picture</span>
          </h2>
          <p className="font-body text-base md:text-lg text-white/80 max-w-md mt-6 leading-relaxed">
            Don&apos;t know the names? Just tap the photos you like — we&apos;ll plan your days.
          </p>
          <Link
            to="/planner"
            data-testid="planner-teaser-cta"
            className="mt-8 inline-flex items-center gap-2 font-display font-900 text-lg bg-white text-[#DF3226] px-8 py-4 rounded-full shadow-brut hover:-translate-y-1 hover:shadow-brut-lg transition-all duration-300"
          >
            <MousePointerClick size={20} /> Open the planner
          </Link>
        </div>

        {/* photo collage */}
        <div className="relative h-64 md:h-80 lg:h-72" aria-hidden="true">
          {TILES.map((t) => (
            <div
              key={t.id}
              className={`absolute w-36 h-44 md:w-48 md:h-56 rounded-2xl overflow-hidden ring-4 ring-white shadow-xl ${t.cls}`}
            >
              <img src={spotImg(t.id)} alt="" loading="lazy" className="w-full h-full object-cover" />
            </div>
          ))}
        </div>
      </div>
    </div>
  </section>
);
